<div
  class="search-container"
  [class.search-container--expanded]="expandable && isExpanded"
  [class.search-container--expandable]="expandable"
  (click)="onContainerClick($event)">
  @if (iconLeading || (expandable && isExpanded)) {
    <i-feather name="search" class="search-icon-leading"></i-feather>
  }

  <input
    type="text"
    [formControl]="searchControl"
    [attr.placeholder]="placeholderKey ? (placeholderKey | translate) : placeholder"
    class="search-input"
    (focus)="onInputFocus()"
    (keydown.escape)="onEscapeKey($event)"
  />

  @if (!iconLeading && (!expandable || !isExpanded)) {
    <i-feather name="search" class="search-icon-trailing"></i-feather>
  }

  @if (expandable && isExpanded) {
    <button
      type="button"
      class="search-close-btn"
      [attr.aria-label]="closeLabel"
      (click)="onCloseClick($event)">
      <span class="search-close-btn__label">{{ closeLabel }}</span>
      <i-feather name="x" class="search-close-btn__icon"></i-feather>
    </button>
  }
</div>
